// extracted by mini-css-extract-plugin
export default {"tooltipAnchor":"styles_tooltipAnchor__tBw+c"};